module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page header-wrapper animate fadeIn"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "block-border radius block shadow"
  }, [_c('page-register-form', {
    attrs: {
      "submit-button-text": "เข้าสู่ระบบ",
      "back-button": false
    },
    on: {
      "submit": _vm.success
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c9868e7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginPage.vue
// module id = 1164
// module chunks = 0